import styles from './main.module.css';
import fbLogo from '../assets/images/fb.svg';
import igLogo from '../assets/images/ig.svg';
import { Alert, Button, Form, Modal } from 'react-bootstrap';
import { axios, getAxiosConfig } from '../utils/apiUtils';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import { useState } from 'react';
import unicefLogo from '../assets/images/mini-logo-unicef-blanco.png';


const CustomGift = (props) => {
    let { id } = useParams();
    const [name, setName] = useState();
    const [email, setEmail] = useState();
    const [fromName, setFromName] = useState();
    const [fromEmail, setFromEmail] = useState();
    const [message, setMessage] = useState();

    let history = useHistory();
    const handleSubmit = e => {
        e.preventDefault();
        e.stopPropagation();
        window.scrollTo(0, 0);

        axios.post(
            `${process.env.REACT_APP_API_URL}/payments/gifts/mercadopago/send/${id}`,
            {
                name,
                email,
                fromName,
                fromEmail,
                message
            },
            getAxiosConfig(),
        )
        .then(() => {
            history.push('/recibe-tu-tarjeta');
        }).catch((mercadoPagoError) => {
            console.error(`Mercado pago error > ${mercadoPagoError}`)
        });
    };


    return (
        <>

        <header className={`fixed-top ${styles.navbarRegala}`}>
            <nav className={`navbar navbar-expand `} aria-label="Eighth navbar example">
                <div className={`container d-flex flex-column flex-lg-row ${styles.navbarContainer}`}>
                    <a className={`navbar-brand ${styles.navbarBrand}`} href="/">
                        Hagamos Cosas Juntos
                    </a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarChungungo"
                    aria-controls="navbarChungungo" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className={`collapse ${styles.collapse} navbar-collapse`}>
                        <ul className="navbar-nav ml-lg-auto">
                            <li className={`nav-item ${styles.navbarBtn}`}>
                                <a className="nav-link" href="/#">Inicio</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </header>

        <section className={`container ${styles.sectionGift}`}>
            <div className="row">
                <div className="col-md-12 text-center">
                    <h3>3.- Cuéntanos: ¿Para Quién Es El Regalo?</h3>
                    <p className={`${styles.customText}`}>Estos datos son importantes para generar tu regalo personalizado y que todo funcione a la perfección.</p>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 mx-auto">
                    <Form onSubmit={handleSubmit}>
                        <span>De parte de:</span>
                        <div className="mb-3">
                            <label>Nombre</label>
                            <input type="text" className={`form-control`} id="fromName" autoFocus="" value={fromName} onChange={(event) => setFromName(event.target.value)}/>
                        </div>

                        <div className="mb-3">
                            <label>Email*</label>
                            <input type="email" className={`form-control`} id="fromEmail" required autoFocus="" value={fromEmail} onChange={(event) => setFromEmail(event.target.value)}/>
                        </div>

                        <span>Para quién:</span>
                        <div className="mb-3">
                            <label>Nombre</label>
                            <input type="text" className={`form-control`} id="toName" autoFocus="" value={name} onChange={(event) => setName(event.target.value)}/>
                        </div>

                        <div className="mb-3">
                            <label>Email*</label>
                            <input type="email" className={`form-control`} id="toEmail" required autoFocus="" value={email} onChange={(event) => setEmail(event.target.value)}/>
                        </div>

                        <div className="mb-3">
                            <label>Escríbele un mensaje</label>
                            <textarea type="text" className={`form-control`} id="toMessage" required autoFocus="" value={message} onChange={(event) => setMessage(event.target.value)}/>
                        </div>

                        <div className="text-center">
                        <button type="submit" className={`${styles.orangeBtn} btn btn-primary text-light`} onClick="location.href='/recibe-tu-tarjeta">Enviar a Chungungo</button>
                        </div>
                    </Form>
                </div>
            </div>
                

            
        </section>


        <footer className={`${styles.footer}`}>
            <div className="container">
            <div className="row">
                <div className="col-12 text-center">
                <ul className="nav justify-content-center">
                    <li className="nav-item">
                    <a className="nav-link" href="/terms_and_conditions">Términos y Condiciones</a>
                    </li>
                    <li className="nav-item">
                    <a className="nav-link" href="/about">Acerca de</a>
                    </li>
                    <li className="nav-item">
                    <a className="nav-link" href="/faq">Preguntas Frecuentes</a>
                    </li>
                </ul>
                <ul className="nav justify-content-center mb-5">
                    <li className="nav-item">
                    <a className="nav-link" href="https://www.facebook.com/somoschungungo" target="_blank" rel="noreferrer"><img src={fbLogo} alt="Facebook" /></a>
                    </li>
                    <li className="nav-item">
                    <a className="nav-link" href="https://www.instagram.com/chungungo_com" target="_blank" rel="noreferrer"><img src={igLogo} alt="Instagram" /></a>
                    </li>
                </ul>
                <small className="text-muted">Todos los derechos reservados© 2021 Chungungo SPA.</small>
                </div>
            </div>
            </div>
            <div className={`${styles.unicef}`}>
                <img src={unicefLogo} alt="Patrocinio Unicef" />
            </div>
        </footer>
        
        </>


    )

}

export default CustomGift;